import React from 'react';
import { cn } from '../../../lib/utils';
import { STUDY_LEVELS } from '../../../data/academicTaxonomy';

interface StudyLevelMultiSelectProps {
  value: string[];
  onChange: (next: string[]) => void;
  options?: ReadonlyArray<string>;
  disabled?: boolean;
  className?: string;
}

const StudyLevelMultiSelect: React.FC<StudyLevelMultiSelectProps> = ({
  value,
  onChange,
  options = STUDY_LEVELS,
  disabled = false,
  className,
}) => {
  const toggle = (level: string) => {
    if (disabled) return;
    if (value.includes(level)) {
      onChange(value.filter((v) => v !== level));
    } else {
      onChange([...value, level]);
    }
  };

  return (
    <div
      role="group"
      aria-label="Study levels"
      className={cn('flex flex-wrap gap-2', className)}
    >
      {options.map((level) => {
        const isSelected = value.includes(level);
        return (
          <button
            key={level}
            type="button"
            disabled={disabled}
            onClick={() => toggle(level)}
            aria-pressed={isSelected}
            className={cn(
              'px-3 py-1.5 rounded-full text-sm font-medium border transition-all',
              'min-h-[36px] focus:outline-none focus:ring-2 focus:ring-cambridge',
              disabled && 'opacity-50 cursor-not-allowed',
              isSelected
                ? 'text-white shadow-sm'
                : 'bg-white hover:bg-gray-50'
            )}
            style={{
              backgroundColor: isSelected ? 'var(--twc-cambridge)' : undefined,
              borderColor: isSelected
                ? 'var(--twc-cambridge)'
                : 'var(--twc-timberwolf)',
              color: isSelected ? '#fff' : 'var(--twc-feldgrau)',
            }}
          >
            {level}
          </button>
        );
      })}
    </div>
  );
};

export default StudyLevelMultiSelect;
